import posthog, { type Properties } from 'posthog-js'

interface SignedInProps extends Properties {
  email: string
}

interface SignUpProps extends Properties {
  email: string
}

export const eventTracker = {
  signedIn: (data: SignedInProps) => {
    posthog.identify(data.email, data)
    posthog.capture('signedIn', data)
  },
  // Sent at once: the page leaves for checkout right after, which can drop a queued event.
  signUp: (data: SignUpProps) =>
    posthog.capture('signUp', data, { send_instantly: true }),
}
